import { store } from "../../redux/store";
import {
  fetchItems,
  fetchTableSessionBill,
  getClient,
  logClientActivity,
  resolveTable,
} from "../../helpers/APIHelpers";
import { setUser } from "../../redux/slices/Client";
import { ItemTypes, UiVersion } from "../../helpers/Constants";
import { getIpAddress } from "../../helpers/fetchIpAddress";
import { v4 as mtIdGenerate } from "uuid";
import { get, set } from "lockr";
import { getClientDetails } from "./pathUtils";

const landingRoutes = ["register", "legal"];

export const loadData = (): null | Promise<boolean> => {
  const { Items, Client } = store.getState();
  if (Items.activeProductCategories.length) return null;
  return fetchItems(Client.user.id, store.dispatch, Items.itemType, "");
};

export const initializeApp = async () => {
  const client = getClientDetails();

  if (client.username) {
    if (landingRoutes.includes(client.username)) {
      return UiVersion.AUTHENTICATION;
    }

    return getClient(client.username, client.segment)
      .then((user) => {
        user.username = client.username;
        user.segment = client.segment;
        return resolveTable(
          client.username,
          client.segment,
          client.tableNumber || "1"
        )
          .catch(() => {
            throw new Error("TABLE_NOT_FOUND");
          })
          .then((table) => {
            if (!table) {
              throw new Error("TABLE_NOT_FOUND");
            }
            store.dispatch(
              setUser({
                user,
                tableNum: table.label,
                table,
              })
            );
            return user;
          });
      })
      .then(async (user) => {
        const ip = await getIpAddress();
        logClientActivity(user.name, ip);
        if (!get("mtId")) {
          set("mtId", mtIdGenerate());
        }
        return user;
      })
      .then(async (user) => {
        await fetchItems(
          user.id,
          store.dispatch,
          ItemTypes.Drink,
          client.segment
        );
        return user;
      })
      .then((user) => {
        if (user.canPlaceOrder) {
          const currentClient = store.getState().Client;
          fetchTableSessionBill(
            user.id,
            currentClient.table?.label || client.tableNumber || "1",
            client.segment,
            store.dispatch,
            currentClient.table?.id
          );
        }
        return user.theme;
      })
      .catch((error) => {
        if (error?.message === "TABLE_NOT_FOUND") {
          return UiVersion.TABLE_NOT_FOUND;
        }
        console.log(error);
        return UiVersion.DEMO;
      });
  }

  return UiVersion.AUTHENTICATION;
};
